import { e as qt, o as Tt, p as $t, a as Ut, f as b } from "./__searchspring__deps__index-_9zotoJQ.js";
import { N as Pt, a as lt, g as Rt } from "./__searchspring__deps__compat.module-ZWqUX18Z.js";
import { y as Lt, u as e, g as Vt } from "./__searchspring__deps__main-kCZHrJ1L.js";
/**
 * @license lucide-react v0.363.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
var Wt = {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
};
/**
 * @license lucide-react v0.363.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Bt = (t) => t.replace(/([a-z0-9])([A-Z])/g, "$1-$2").toLowerCase();
/**
 * @license lucide-react v0.363.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Ft = (t, n) => {
  const a = Pt(
    ({
      color: r = "currentColor",
      size: s = 24,
      strokeWidth: i = 2,
      absoluteStrokeWidth: c,
      className: w = "",
      children: d,
      ...u
    }, p) => Lt(
      "svg",
      {
        ref: p,
        ...Wt,
        width: s,
        height: s,
        stroke: r,
        strokeWidth: c ? Number(i) * 24 / Number(s) : i,
        className: ["lucide", `lucide-${Bt(t)}`, w].join(" "),
        ...u
      },
      [
        ...n.map(([g, f]) => Lt(g, f)),
        ...Array.isArray(d) ? d : [d]
      ]
    )
  );
  return a.displayName = `${t}`, a;
};
/**
 * @license lucide-react v0.363.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Dt = Ft("ArrowLeftRight", [
  ["path", { d: "M8 3 4 7l4 4", key: "9rb6wj" }],
  ["path", { d: "M4 7h16", key: "6tx8e3" }],
  ["path", { d: "m16 21 4-4-4-4", key: "siv7j2" }],
  ["path", { d: "M20 17H4", key: "h6l3hr" }]
]);
/**
 * @license lucide-react v0.363.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Ht = Ft("Star", [
  [
    "polygon",
    {
      points: "12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2",
      key: "8f66p6"
    }
  ]
]), Jt = (t) => {
  t.preventDefault();
  const n = t.currentTarget, a = document.querySelector("cart-notification") || document.querySelector("cart-drawer"), r = new FormData(n);
  a && (r.append(
    "sections",
    // @ts-expect-error - --
    a.getSectionsToRender().map((i) => i.id)
  ), r.append("sections_url", window.location.pathname), a.setActiveElement(document.activeElement));
  const s = {
    body: r,
    method: "POST",
    headers: {
      "X-Requested-With": "XMLHttpRequest",
      Accept: "application/json"
    }
  };
  fetch(`${window.routes.cart_add_url}`, s).then((i) => i.json()).then((i) => {
    const c = n.closest("quick-add-modal");
    a && (c ? (document.body.addEventListener("modalClosed", () => {
      setTimeout(() => {
        a.renderContents(i);
      });
    }, {
      once: !0
    }), c.hide(!0)) : a.renderContents(i));
  }).catch((i) => {
    console.error(i);
  }).finally(() => {
    a && a.classList.contains("is-empty") && a.classList.remove("is-empty"), window.customization && window.customization.refreshCartButtons && window.customization.refreshCartButtons();
  });
};
function Ot(t) {
  var n, a, r = "";
  if (typeof t == "string" || typeof t == "number")
    r += t;
  else if (typeof t == "object")
    if (Array.isArray(t)) {
      var s = t.length;
      for (n = 0; n < s; n++)
        t[n] && (a = Ot(t[n])) && (r && (r += " "), r += a);
    } else
      for (a in t)
        t[a] && (r && (r += " "), r += a);
  return r;
}
function Xt() {
  for (var t, n, a = 0, r = "", s = arguments.length; a < s; a++)
    (t = arguments[a]) && (n = Ot(t)) && (r && (r += " "), r += n);
  return r;
}
const Kt = qt({
  prefix: "tw-"
});
function m(...t) {
  return Kt(Xt(t));
}
const wt = {
  default: {
    star: "tw-text-primary",
    emptyStar: "tw-text-tertiary"
  }
}, Zt = ({
  className: t,
  ...n
}) => {
  const {
    rating: a,
    totalStars: r = 5,
    size: s = 20,
    Icon: i = e(Ht, {}),
    variant: c = "default"
  } = n, w = Math.floor(a), d = a % 1 > 0 ? e(Gt, {
    variant: c,
    fillPercentage: a % 1,
    size: s,
    className: m(wt[c].emptyStar),
    Icon: i
  }) : null;
  return e("div", {
    className: m("tw-flex tw-items-center tw-gap-2", t),
    ...n,
    children: [[...Array(w)].map((u, p) => lt.cloneElement(i, {
      key: p,
      size: s,
      className: m("tw-fill-current")
    })), d, [...Array(r - w - (d ? 1 : 0))].map((u, p) => lt.cloneElement(i, {
      key: p + w + 1,
      size: s,
      className: m("tw-fill-current", wt[c].emptyStar)
    }))]
  });
}, Gt = ({
  ...t
}) => {
  const {
    fillPercentage: n,
    size: a,
    className: r,
    Icon: s
  } = t;
  return e("div", {
    style: {
      position: "relative",
      display: "inline-block"
    },
    children: [lt.cloneElement(s, {
      size: a,
      className: m("tw-fill-current", r)
    }), e("div", {
      style: {
        position: "absolute",
        top: 0,
        overflow: "hidden",
        width: `${n * 100}%`
      },
      className: m(wt[t.variant].star),
      children: lt.cloneElement(s, {
        size: a,
        className: m("tw-fill-current")
      })
    })]
  });
}, Qt = (t) => {
  try {
    return JSON.parse(t ?? "[]");
  } catch {
    return [];
  }
}, ot = window.searchspring.dataTags, Yt = (t) => {
  var c, w, d;
  let n = !0;
  const a = (w = (c = window.searchspring) == null ? void 0 : c.translations) == null ? void 0 : w.instalments, r = Math.floor(t / 1e4);
  let s = Number((d = window == null ? void 0 : window.searchspring) == null ? void 0 : d.instalments), i;
  return r >= 2 && r < s ? (i = t && Math.ceil(t / r), s = r) : r >= s ? i = t && Math.ceil(t / s) : (i = t && Math.ceil(t / s), n = !1), n ? a.replace("__instalments__", s).replace("__fixedInstalments__", b(i)) : null;
}, te = (t) => {
  var s, i, c, w;
  const n = (i = (s = window.searchspring) == null ? void 0 : s.translations) == null ? void 0 : i.instalments, a = Number((c = window == null ? void 0 : window.searchspring) == null ? void 0 : c.instalments), r = t && Math.ceil(t / a);
  return n.replace("__instalments__", (w = window == null ? void 0 : window.searchspring) == null ? void 0 : w.instalments).replace("__fixedInstalments__", b(r));
}, oe = Tt((t) => {
  var f, y, x, v, _, N, k, M, j, C, S, A, z, I, E, L, T, $, F, O, q, U, P, R, V, W, B, D, H, J, X, K, Z, G, Q, Y, tt, et, at, rt, st, nt, l, h, dt, pt, mt, ut, ht, bt, ft, gt, yt, xt, vt, _t, Nt, kt, Mt, jt, Ct, St, At, zt, It, Et;
  const n = Rt(), a = t.product, r = (f = window.searchspring) == null ? void 0 : f.limitInstalmentsEnabled, s = Qt(String((y = a.attributes) == null ? void 0 : y.mfield_andes_pim_jp_tags)), i = (v = (x = a.mappings) == null ? void 0 : x.core) != null && v.msrp && ((_ = a.mappings.core) != null && _.price) ? ((N = a.mappings.core) == null ? void 0 : N.msrp) > ((k = a.mappings.core) == null ? void 0 : k.price) : !1, c = Math.round(((((j = (M = a.mappings) == null ? void 0 : M.core) == null ? void 0 : j.msrp) ?? 0) - (((S = (C = a.mappings) == null ? void 0 : C.core) == null ? void 0 : S.price) ?? 0)) / (((z = (A = a.mappings) == null ? void 0 : A.core) == null ? void 0 : z.msrp) ?? 0) * 100), w = ot == null ? void 0 : ot.filter((o) => (
    // @ts-expect-error No types for this
    s == null ? void 0 : s.some((it) => (it == null ? void 0 : it.tag_value_en) === o.id)
  )), d = $t(typeof ((I = t.product.attributes) == null ? void 0 : I.mfield_andes_pim_jp_assets) == "string" ? (E = t.product.attributes) == null ? void 0 : E.mfield_andes_pim_jp_assets : "[]"), u = Array.isArray(d) ? d.filter((o) => {
    const it = (o == null ? void 0 : o.uri_internal) && (o.uri_internal.endsWith(".png") || o.uri_internal.endsWith(".jpg"));
    return (o == null ? void 0 : o.private) === 0 && (o == null ? void 0 : o.visible) === 1 && it;
  }).slice(1, 5) : [], p = typeof ((L = a.attributes) == null ? void 0 : L.ss_available) == "string" || typeof ((T = a.attributes) == null ? void 0 : T.ss_available) == "number" ? (($ = a.attributes) == null ? void 0 : $.ss_available) === "1" || ((F = a.attributes) == null ? void 0 : F.ss_available) === 1 : !1, g = typeof ((q = (O = a.mappings) == null ? void 0 : O.core) == null ? void 0 : q.rating) < "u" && Number((P = (U = a.mappings) == null ? void 0 : U.core) == null ? void 0 : P.ratingCount) > 0;
  return e("div", {
    className: "tw-group tw-relative tw-z-0 tw-flex tw-max-w-xs tw-flex-col tw-gap-3.5 tw-p-2 tw-transition-shadow tw-duration-300 hover:tw-shadow-lg sm:tw-p-5",
    children: [e("div", {
      className: "tw-relative",
      children: [e("span", {
        className: "wishlist-hero-custom-button-wrapper !tw-absolute -tw-right-[3px] -tw-top-[3px] !tw-z-[4] !tw-w-2/12 group-hover:!tw-block sm:!tw-hidden ",
        children: e("div", {
          className: "wishlist-hero-custom-button wishlisthero-floating !tw-z-[4]",
          "data-wlh-id": t.product.id,
          "data-wlh-link": (V = (R = t.product.mappings) == null ? void 0 : R.core) == null ? void 0 : V.url,
          "data-wlh-variantid": (W = t.product.attributes) == null ? void 0 : W.ss_id,
          "data-wlh-price": ((D = (B = t.product.mappings) == null ? void 0 : B.core) == null ? void 0 : D.price) ?? 0,
          "data-wlh-name": (J = (H = t.product.mappings) == null ? void 0 : H.core) == null ? void 0 : J.name,
          "data-wlh-image": (K = (X = t.product.mappings) == null ? void 0 : X.core) == null ? void 0 : K.imageUrl,
          "data-wlh-mode": "icon_only"
        })
      }), e("div", {
        className: "tw-absolute tw-left-2 tw-top-2 tw-flex tw-w-[calc(100%-40px)] tw-flex-wrap tw-items-center tw-gap-1",
        children: [i && e("div", {
          className: "tw-max-w-max tw-rounded tw-bg-brand-primary-accent tw-px-1 tw-py-0.5",
          children: e("span", {
            className: "tw-typ-h5-subtopic-3-b tw-leading-none tw-text-brand-secondary",
            children: [c, "% OFF"]
          })
        }), w == null ? void 0 : w.map((o) => e("div", {
          style: {
            "--order": o == null ? void 0 : o.order
          },
          className: "tw-order-[var(--order, 9999)] !tw-max-w-max",
          children: o != null && o.image_url ? e("img", {
            className: "tw-object-fit tw-h-[15px] tw-w-[15px] md:tw-h-[25px] md:tw-w-[25px]",
            src: o == null ? void 0 : o.image_url
          }) : e("span", {
            className: "tw-order tw-typ-h5-subtopic-3-b tw-rounded tw-leading-none",
            children: o == null ? void 0 : o.label.toUpperCase()
          })
        }))]
      }), e("img", {
        className: m("tw-aspect-[9/10] tw-min-w-full tw-object-contain", u.length > 0 && "group-hover:tw-opacity-0"),
        src: (G = (Z = t.product.mappings) == null ? void 0 : Z.core) == null ? void 0 : G.imageUrl
      }), u.length > 0 && e("div", {
        class: "tw-absolute tw-inset-0 tw-hidden group-hover:tw-block supports-hover:hover:tw-bg-background",
        children: e("img", {
          class: "tw-peer tw-absolute tw-z-[1] !tw-h-full tw-w-auto tw-object-cover",
          src: (Q = u[0]) == null ? void 0 : Q.uri_internal,
          width: "auto",
          height: "auto"
        })
      })]
    }), e("div", {
      className: "tw-flex tw-flex-col tw-gap-2.5",
      children: [e("div", {
        className: "tw-flex tw-flex-nowrap tw-items-center tw-justify-between",
        children: [e("div", {
          "data-product": "grid",
          className: "tw-flex tw-items-center tw-overflow-hidden",
          "data-product-handle": (Y = t.product.attributes) == null ? void 0 : Y.handle,
          children: e("div", {
            className: "variants tw-flex tw-min-h-[30px] tw-items-center"
          })
        }), !!((tt = window.comparator) != null && tt.enabled) && e("div", {
          class: "tw-relative tw-flex tw-w-8",
          children: e("div", {
            class: "tw-group/comparator tw-relative tw-inset-0 tw-flex tw-w-full tw-items-center tw-justify-end tw-rounded-full",
            onClick: (o) => {
              o.stopPropagation();
            },
            children: [e("input", {
              type: "checkbox",
              "data-image": (at = (et = t.product.mappings) == null ? void 0 : et.core) == null ? void 0 : at.imageUrl,
              "data-button-type": "compare-product-button",
              "data-id": (rt = t.product.attributes) == null ? void 0 : rt.handle,
              class: "!tw-hidden [&+label]:tw-bg-box-background [&:checked+label]:tw-bg-brand-tertiary [&:checked+label]:tw-text-background [&:disabled+label]:tw-cursor-not-allowed [&:disabled+label]:tw-opacity-60",
              id: ((st = t.product.attributes) == null ? void 0 : st.handle) + n
            }), e("label", {
              class: "tw-inline-flex tw-cursor-pointer tw-select-none tw-items-center tw-px-2 tw-py-1",
              htmlFor: ((nt = t.product.attributes) == null ? void 0 : nt.handle) + n,
              children: [e("span", {
                children: e(Dt, {
                  size: 16
                })
              }), e("span", {
                class: "tw-typ-small-1 tw-w-0 tw-max-w-max tw-overflow-hidden tw-transition-all tw-duration-500 group-hover/comparator:tw-ml-2 group-hover/comparator:tw-w-[200px]",
                children: (l = window.comparator) == null ? void 0 : l.buttonText
              })]
            })]
          })
        })]
      }), e("hr", {
        className: "tw-border-b-0 tw-border-solid tw-border-border"
      })]
    }), e("div", {
      className: "tw-flex tw-flex-col",
      children: [e("div", {
        className: "tw-flex tw-w-full tw-justify-between",
        children: [e("span", {
          className: "tw-typ-eyebrow-a tw-text-primary",
          children: (dt = (h = t.product.mappings) == null ? void 0 : h.core) == null ? void 0 : dt.brand
        }), g && e("div", {
          className: "tw-flex tw-items-center tw-gap-1",
          children: [e(Zt, {
            size: 10,
            className: "tw-gap-0.5",
            rating: ((mt = (pt = a.mappings) == null ? void 0 : pt.core) == null ? void 0 : mt.rating) ?? 5
          }), e("span", {
            className: "tw-text-[8px]",
            children: Intl.NumberFormat(Ut, {
              notation: "compact"
            }).format(Number((ht = (ut = a == null ? void 0 : a.mappings) == null ? void 0 : ut.core) == null ? void 0 : ht.ratingCount))
          })]
        })]
      }), e("span", {
        className: "tw-typ-body-3 tw-line-clamp-2 tw-min-h-[2lh] tw-w-full tw-overflow-hidden tw-text-ellipsis tw-text-tertiary",
        children: (ft = (bt = t.product.mappings) == null ? void 0 : bt.core) == null ? void 0 : ft.name
      })]
    }), e("div", {
      className: "tw-flex tw-flex-col",
      children: [e("div", {
        className: "tw-typ-body-2 tw-flex tw-flex-col tw-flex-wrap tw-gap-x-1 md:tw-flex-row",
        children: [e("span", {
          className: m(i && "tw-text-brand-primary-accent"),
          children: b((((yt = (gt = t.product.mappings) == null ? void 0 : gt.core) == null ? void 0 : yt.price) ?? 0) * 100)
        }), e("span", {
          className: m("tw-w-0 tw-text-tertiary tw-line-through tw-opacity-0", i && "tw-w-auto tw-opacity-100"),
          children: b((((vt = (xt = t.product.mappings) == null ? void 0 : xt.core) == null ? void 0 : vt.msrp) ?? 0) * 100)
        })]
      }), ((_t = window.searchspring) == null ? void 0 : _t.instalmentsEnabled) && e("div", {
        className: "tw-typ-small-1 tw-text-tertiary",
        children: r ? Yt((((kt = (Nt = t.product.mappings) == null ? void 0 : Nt.core) == null ? void 0 : kt.price) ?? 0) * 100) : te((((jt = (Mt = t.product.mappings) == null ? void 0 : Mt.core) == null ? void 0 : jt.price) ?? 0) * 100)
      })]
    }), e("form", {
      onSubmit: Jt,
      children: [e("input", {
        type: "hidden",
        name: "id",
        value: typeof ((Ct = t.product.attributes) == null ? void 0 : Ct.ss_id) == "string" ? (St = t.product.attributes) == null ? void 0 : St.ss_id : ""
      }), e("button", {
        disabled: !p,
        type: "submit",
        className: "tw-typ-buttons-a tw-button-primary tw-w-full tw-px-5 tw-py-1 tw-uppercase tw-transition-opacity tw-duration-300 supports-hover:tw-opacity-0 supports-hover:group-hover:tw-opacity-100 sm:tw-py-2.5",
        children: p ? (zt = (At = window.searchspring) == null ? void 0 : At.translations) == null ? void 0 : zt.addToCart : (Et = (It = window.searchspring) == null ? void 0 : It.translations) == null ? void 0 : Et.outOfStock
      })]
    })]
  });
}), ee = (t) => {
  try {
    return JSON.parse(t ?? "[]");
  } catch {
    return [];
  }
}, ct = window.searchspring.dataTags, ae = (t) => {
  switch (t) {
    case 0:
      return "[&~div>div>span.slide-0]:hover:tw-bg-black";
    case 1:
      return "[&~div>div>span.slide-1]:hover:tw-bg-black";
    case 2:
      return "[&~div>div>span.slide-2]:hover:tw-bg-black";
    case 3:
      return "[&~div>div>span.slide-3]:hover:tw-bg-black";
    default:
      return "";
  }
}, re = (t) => {
  var c, w, d;
  let n = !0;
  const a = (w = (c = window.searchspring) == null ? void 0 : c.translations) == null ? void 0 : w.instalments, r = Math.floor(t / 1e4);
  let s = Number((d = window == null ? void 0 : window.searchspring) == null ? void 0 : d.instalments), i;
  return r >= 2 && r < s ? (i = t && Math.ceil(t / r), s = r) : r >= s ? i = t && Math.ceil(t / s) : (i = t && Math.ceil(t / s), n = !1), n ? a.replace("__instalments__", s).replace("__fixedInstalments__", b(i)) : null;
}, se = (t) => {
  var s, i, c, w;
  const n = (i = (s = window.searchspring) == null ? void 0 : s.translations) == null ? void 0 : i.instalments, a = Number((c = window == null ? void 0 : window.searchspring) == null ? void 0 : c.instalments), r = t && Math.ceil(t / a);
  return n.replace("__instalments__", (w = window == null ? void 0 : window.searchspring) == null ? void 0 : w.instalments).replace("__fixedInstalments__", b(r));
}, ce = Tt((t) => {
  var u, p, g, f, y, x, v, _, N, k, M, j, C, S, A, z, I, E, L, T, $, F, O, q, U, P, R, V, W, B, D, H, J, X, K, Z, G, Q, Y, tt, et, at, rt, st, nt;
  const n = t.product, a = (u = window.searchspring) == null ? void 0 : u.limitInstalmentsEnabled, r = ee(String((p = n.attributes) == null ? void 0 : p.mfield_andes_pim_jp_tags)), s = (f = (g = n.mappings) == null ? void 0 : g.core) != null && f.msrp && ((y = n.mappings.core) != null && y.price) ? ((x = n.mappings.core) == null ? void 0 : x.msrp) > ((v = n.mappings.core) == null ? void 0 : v.price) : !1, i = Math.round(((((N = (_ = n.mappings) == null ? void 0 : _.core) == null ? void 0 : N.msrp) ?? 0) - (((M = (k = n.mappings) == null ? void 0 : k.core) == null ? void 0 : M.price) ?? 0)) / (((C = (j = n.mappings) == null ? void 0 : j.core) == null ? void 0 : C.msrp) ?? 0) * 100), c = ct == null ? void 0 : ct.filter((l) => (
    // @ts-expect-error No types for this
    r == null ? void 0 : r.some((h) => (h == null ? void 0 : h.tag_value_en) === l.id)
  )), w = $t(typeof ((S = t.product.attributes) == null ? void 0 : S.mfield_andes_pim_jp_assets) == "string" ? (A = t.product.attributes) == null ? void 0 : A.mfield_andes_pim_jp_assets : "[]"), d = Array.isArray(w) ? w.filter((l) => (l == null ? void 0 : l.private) === 0 && (l == null ? void 0 : l.visible) === 1).slice(1, 5) : [];
  return e("div", {
    className: "tw-group tw-relative tw-z-0 tw-max-w-xs tw-p-1 sm:tw-p-5",
    children: [e("div", {
      className: "tw-relative",
      children: [e("span", {
        className: "wishlist-hero-custom-button-wrapper !tw-absolute -tw-right-[3px] -tw-top-[3px] !tw-z-[4] !tw-w-2/12 group-hover:!tw-block sm:!tw-hidden ",
        children: e("div", {
          className: "wishlist-hero-custom-button wishlisthero-floating !tw-z-[4]",
          "data-wlh-id": t.product.id,
          "data-wlh-link": (I = (z = t.product.mappings) == null ? void 0 : z.core) == null ? void 0 : I.url,
          "data-wlh-variantid": (E = t.product.attributes) == null ? void 0 : E.ss_id,
          "data-wlh-price": ((T = (L = t.product.mappings) == null ? void 0 : L.core) == null ? void 0 : T.price) ?? 0,
          "data-wlh-name": (F = ($ = t.product.mappings) == null ? void 0 : $.core) == null ? void 0 : F.name,
          "data-wlh-image": (q = (O = t.product.mappings) == null ? void 0 : O.core) == null ? void 0 : q.imageUrl,
          "data-wlh-mode": "icon_only"
        })
      }), e("div", {
        className: "tw-absolute tw-left-2 tw-top-2 tw-flex tw-w-[calc(100%-40px)] tw-flex-wrap tw-items-center tw-gap-1",
        children: [s && e("div", {
          className: "tw-max-w-max tw-rounded tw-bg-box-background tw-px-1 tw-py-0.5",
          children: e("span", {
            className: "tw-typ-h5-subtopic-3-b tw-leading-none tw-text-brand-tertiary",
            children: [i, "% OFF"]
          })
        }), c == null ? void 0 : c.map((l) => e("div", {
          style: {
            "--order": l == null ? void 0 : l.order
          },
          className: "tw-order-[var(--order, 9999)] !tw-max-w-max",
          children: l != null && l.image_url ? e("img", {
            className: "tw-object-fit tw-h-[15px] tw-w-[15px] md:tw-h-[25px] md:tw-w-[25px]",
            src: l == null ? void 0 : l.image_url
          }) : e("span", {
            className: "tw-order tw-typ-h5-subtopic-3-b tw-rounded tw-leading-none",
            children: l == null ? void 0 : l.label.toUpperCase()
          })
        }))]
      }), e("img", {
        className: "tw-aspect-[4/5] tw-min-w-full tw-object-contain",
        src: (P = (U = t.product.mappings) == null ? void 0 : U.core) == null ? void 0 : P.imageUrl
      }), d.length > 0 && e("div", {
        class: "tw-align-center tw-absolute tw-top-0 tw-hidden tw-h-full tw-w-full tw-flex-row tw-items-center tw-overflow-hidden tw-opacity-0 hover:tw-opacity-100 supports-hover:hover:tw-bg-background supports-hover:sm:tw-flex",
        children: [d.map((l, h) => e(Vt, {
          children: [e("div", {
            class: "tw-z-[3] !tw-block tw-h-full !tw-w-full [&+img]:hover:tw-opacity-100 " + ae(h)
          }), e("img", {
            class: "tw-peer tw-absolute tw-z-[1] !tw-h-full tw-w-auto tw-object-cover tw-opacity-0",
            src: l == null ? void 0 : l.uri_internal,
            width: "auto",
            height: "auto"
          })]
        })), e("div", {
          class: "tw-absolute tw-bottom-[10px] tw-z-[5] tw-flex tw-w-full tw-items-center tw-justify-center group-hover:!tw-opacity-100 peer-hover:[&>div>span]:tw-bg-black ",
          children: e("div", {
            class: "!tw-flex tw-max-w-full tw-items-center tw-justify-center tw-gap-2 ",
            children: d.map((l, h) => e("span", {
              class: `slide-${h} tw-z-[1] tw-mr-[8px] !tw-block tw-h-[1px] tw-w-[17px] tw-bg-gray-400`
            }))
          })
        })]
      })]
    }), e("div", {
      className: "tw-flex tw-flex-col",
      children: [e("span", {
        className: "tw-typ-eyebrow-b tw-text-tertiary",
        children: (V = (R = t.product.mappings) == null ? void 0 : R.core) == null ? void 0 : V.brand
      }), e("span", {
        className: "tw-typ-body-1 tw-w-full tw-truncate",
        children: (B = (W = t.product.mappings) == null ? void 0 : W.core) == null ? void 0 : B.name
      })]
    }), e("div", {
      className: "tw-typ-body-3 tw-flex tw-flex-wrap tw-gap-1",
      children: [e("span", {
        className: m("tw-hidden tw-text-tertiary tw-line-through tw-opacity-0", s && "tw-block tw-opacity-100"),
        children: b((((H = (D = t.product.mappings) == null ? void 0 : D.core) == null ? void 0 : H.msrp) ?? 0) * 100)
      }), e("span", {
        children: b((((X = (J = t.product.mappings) == null ? void 0 : J.core) == null ? void 0 : X.price) ?? 0) * 100)
      })]
    }), e("div", {
      className: "tw-flex tw-flex-col",
      children: ((K = window.searchspring) == null ? void 0 : K.instalmentsEnabled) && e("div", {
        className: "tw-typ-small-1 tw-text-tertiary",
        children: a ? re((((G = (Z = t.product.mappings) == null ? void 0 : Z.core) == null ? void 0 : G.price) ?? 0) * 100) : se((((Y = (Q = t.product.mappings) == null ? void 0 : Q.core) == null ? void 0 : Y.price) ?? 0) * 100)
      })
    }), e("hr", {
      className: "tw-border-b-0 tw-border-solid tw-border-border"
    }), e("div", {
      className: "tw-flex tw-flex-wrap tw-items-center tw-justify-between",
      children: [e("div", {
        "data-product": "grid",
        className: "tw-py-2",
        "data-product-handle": (tt = t.product.attributes) == null ? void 0 : tt.handle,
        children: e("div", {
          className: "variants"
        })
      }), !!((et = window.comparator) != null && et.enabled) && e("div", {
        className: "!tw-mt-1 !tw-flex tw-flex-grow tw-items-center tw-justify-end",
        onClick: (l) => l.stopPropagation(),
        children: [e("input", {
          type: "checkbox",
          "data-image": (rt = (at = t.product.mappings) == null ? void 0 : at.core) == null ? void 0 : rt.imageUrl,
          "data-button-type": "compare-product-button",
          "data-id": (st = t.product.attributes) == null ? void 0 : st.handle,
          id: t.product.id,
          className: " border-gray-300 tw-peer tw-order-2 !tw-h-[18px] !tw-w-[18px] tw-accent-background checked:!tw-opacity-100 group-hover:!tw-opacity-100 sm:!tw-opacity-0"
        }), e("label", {
          className: "tw-typ-body-3 tw-order-1 tw-cursor-pointer tw-select-none tw-gap-2 tw-px-2 tw-text-secondary group-hover:!tw-opacity-100 peer-checked:tw-block sm:!tw-opacity-0",
          for: t.product.id,
          children: (nt = window.comparator) == null ? void 0 : nt.buttonText
        })]
      })]
    })]
  });
});
export {
  oe as P,
  ce as a,
  Xt as b,
  Ft as c,
  m as d
};
